export const isStickerMessage = (message) =>
  (message?.message_type || message?.media?.message_type) === 'sticker';
